import * as Actions from "../actions/_ActionTypes";
import * as Pre from "../actions/_PreActionNames";

const initState = {
  isLoading: false,
  cameras: []
};

const CameraReducer = (state = initState, action) => {
  const _state = { ...state };
  if (action.socket && action.socket.send) {
    if (action.type.indexOf("CAMERA") == 0) {
      _state.isLoading = true;
    }
    return _state;
  }
  var parsedData = null;
  if (action.payload && action.payload.data) {
    parsedData = JSON.parse(action.payload.data);
  }
  switch (action.type) {

    // CAMERA_ADD moved to DeviceReducer -> DEVICE_ADD
    // case Pre.CAMERA + Actions.ADD:
    //   if (parsedData) {
    //     // check to prevent insert duplicated
    //     var isExist = false;
    //     for (var i in _state.cameras) {
    //       if (_state.cameras[i].cameraId == parsedData.cameraId) {
    //         isExist = true;
    //         break;
    //       }
    //     }
    //     if (!isExist) {
    //       _state.cameras.push(parsedData);
    //     }
    //   }
    //   break;

    // CAMERA_UPDATE moved to DeviceReducer -> CAMERA_UPDATE
    // case Pre.CAMERA + Actions.UPDATE:
    //   // will update information of device like name or type.(value won't change.)
    //   var model = parsedData;
    //   if (model) {
    //     for (var i in _state.cameras) {
    //       var ar = _state.cameras[i];
    //       if (ar.cameraId == model.cameraId) {
    //         ar.cameraName = model.cameraName;
    //         ar.ip = model.ip;
    //         ar.port = model.port;
    //         ar.channel = model.channel;
    //         ar.userName = model.userName;

    //         break;
    //       }
    //     }
    //   }
    //   break;
    case Pre.CAMERA + Actions.REMOVE:
      var cameraId = action.payload.cameraId;
      if (cameraId) {
        for (var i in _state.cameras) {
          if (_state.cameras[i].cameraId == cameraId) {
            // removing i_th element using splice(index , length)
            _state.cameras.splice(i, 1);
            break;
          }
        }
      }
      break;
    case Pre.CAMERA + Actions.ALL:
      if (parsedData && Array.isArray(parsedData)) {
        parsedData.map(c => {
          var existed = _state.cameras.filter(s => {
            if (s.cameraId == c.cameraId) return s;
          })[0];
          if (existed) {
            _state.cameras[_state.cameras.indexOf(existed)] = c; // override to existed
          } else {
            _state.cameras.push(c); // insert as new
          }
        });
      }
      break;
  }
  _state.isLoading = false;
  return _state;
};

export default CameraReducer;
